export const DISPUTE_WINDOW_MS = 24 * 60 * 60 * 1000;

export const DISPUTE_REASONS = [
  { value: 'recapito_inesistente', label: 'Recapito inesistente' },
  { value: 'non_pertinente', label: 'Lead non pertinente' },
  { value: 'duplicato', label: 'Pratica duplicata' },
];

export function leadAssignmentTime(lead) {
  const raw = lead?.assigned_at || lead?.created_at;
  if (!raw) return null;
  const dt = new Date(raw);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function canDisputeLead(lead, { isAssigned = false, isAdmin = false } = {}) {
  if (!lead) return false;
  if (lead.disputed || String(lead.stato || '').toLowerCase() === 'contestato') return false;
  if (!isAdmin && !isAssigned) return false;
  if (!isAdmin && !String(lead.assigned_to || '').trim()) return false;
  const assignedAt = leadAssignmentTime(lead);
  if (!assignedAt) return false;
  return Date.now() - assignedAt.getTime() <= DISPUTE_WINDOW_MS;
}
